<div class="g-3" id="content" [formGroup]="formFields">
    <div class="row" *ngIf="premiums">
        <div class="col-md-12">

            <h4 class="mb-3">Premium</h4>
            <div class="form_sections">
              <!-- Premium Exc IPT -->
              <div class="row">
                <div class="col-md-5 fw-300">Premium Exc IPT:</div>
                <div class="col-md-7 fw-300">&pound; {{ modelObject?.financial_details?.financial_summary[0]?.premium_excl_ipt | number:'1.2-2' }}</div>
              </div>

              <div class="row mt-3">
                <div class="col-md-5 fw-300">Insurance Premium Tax (IPT) at 12%:</div>
                <div class="col-md-7 fw-300">&pound; {{ modelObject?.financial_details?.financial_summary[0]?.ipt_value | number:'1.2-2' }}</div>
              </div>

              <div class="row mt-3">
                <div class="col-md-5 fw-300">Peliwica Fee:</div>
                <div class="col-md-7 fw-300">&pound; {{ peliwica_fee }}</div>
              </div>

              <div class="row mt-3">
                <div class="col-md-5 fw-300">Total Premium Including IPT:</div>
                <div class="col-md-7 fw-300">&pound; {{ modelObject?.financial_details?.financial_summary[0]?.total_premium_inc_ipt | number:'1.2-2' }}</div>
              </div>

            </div>

            <h4 class="mb-3">Quote Summary</h4>
            <div class="form_sections">

              <div class="row">
                <div class="col-md-5 fw-300">Product:</div>
                <div class="col-md-7 fw-500">Peliwica Horsebox Breakdown</div>
              </div>

              <div class="row mt-3">
                <div class="col-md-5 fw-300">Quote Reference:</div>
                <div class="col-md-7 fw-500">{{ modelObject?.quote_ref_number }}</div>
              </div>

              <div class="row mt-3">
                <div class="col-md-5 fw-300">Cover Dates:</div>
                <div class="col-md-7 fw-500">{{ coverPeriod }}</div>
              </div>
            </div>

            <h4 class="mb-3">Documents</h4>
            <div class="form_sections mt-3">
              <div class="mt-4 d-flex gap-2 flex-wrap ml-2" style="justify-content: space-evenly;" *ngIf="documents?.length">
                <button
                  type="button"
                  class="btn btn-success btn-sm px-3"
                  *ngIf="policyWordingDoc"
                  (click)="downloadDocument('download', policyWordingDoc)"
                >
                  Policy Wording
                </button>

                <button
                  type="button"
                  class="btn btn-success btn-sm px-3"
                  *ngIf="quoteScheduleDoc"
                  (click)="downloadDocument('download', quoteScheduleDoc)"
                >
                  Quote Schedule
                </button>

                <button
                  type="button"
                  class="btn btn-success btn-sm px-3 ml-2"
                  *ngIf="ipidDoc"
                  (click)="downloadDocument('download', ipidDoc)"
                >
                  IPID
                </button>
              </div>
            </div>

            <div class="row">
                <div class="col-md-6">
                    <button type="button" class="btn btn-light btn-sm" (click)="BackToVehicles.emit()">Back</button>
                </div>
                <div class="col-md-6  text-right">
                    <button type="submit" class="btn btn-success btn-sm ml-2" *ngIf="!isBroker" (click)="saveQuote()">Save and View Quote</button>
                </div>
            </div>

        </div>

    </div>
</div>
